<ush-modal-map class="performance-map" *ngIf="!inlineMap() && showMap && !newWorkflow" [inlineMap]="false"
  [lat]="perfGroup.cinema.latitude" [lng]="perfGroup.cinema.longitude"
  [address]="addressExists() ? perfGroup.cinema.place.address : ''" (hide)="onHideMap()">
</ush-modal-map>

<div class="panel-showtimes ush-cinema-content">
  <div class="panel-content">
    @if (!hideAddress) {
    <div class="cinema-location" *ngIf="perfGroup.cinema.place.address && !newWorkflow">
      <ng-container *ngIf="perfGroup.cinema.latitude && perfGroup.cinema.longitude; else staticCinemaAddress">
        <a class="ush-cinema-open-map" *ngIf="!inlineMap() || (inlineMap() && !showMap)" role="button" tabindex="0"
          (click)="openMap()" (keydown)="openMapKeydown($event)">
          <fa-icon [icon]="locationIcon" class="map-icon ush-cinema-map-icon"></fa-icon>
          <span>{{ perfGroup?.cinema?.place?.address }} {{ perfGroup?.cinema?.place?.city?.name }}</span>
        </a>
      </ng-container>

      <!-- cinema address -->
      <ng-template #staticCinemaAddress>
        <div class="cinema-address ush-cinema-address" *ngIf="addressExists()">
          <fa-icon [icon]="locationIcon" class="ush-cinema-address-marker"></fa-icon>
          <span class="ush-cinema-address--place">{{ perfGroup.cinema.place.address }}</span>,
          <span class="ush-cinema-address--city">{{ perfGroup.cinema.place.city.name }}</span>
        </div>
      </ng-template>

      <!-- CLOSE INLINE MAP -->
      <a class="ush-cinema-close-map" *ngIf="inlineMap() && showMap" style="margin-left: auto"
        (click)="closeInlineMap()">
        <fa-icon [icon]="closeIncon" class="map-icon ush-cinema-map-icon"></fa-icon>
      </a>
    </div>
    }

    <div class="inlineMap" *ngIf="inlineMap() && !newWorkflow && showMap">
      <ush-modal-map class="performance-map" [inlineMap]="true" [lat]="perfGroup.cinema.latitude"
        [lng]="perfGroup.cinema.longitude" [address]="addressExists() ? perfGroup.cinema.place.address : ''"
        (hide)="onHideMap()">
      </ush-modal-map>
    </div>

    <div class="showtime-dates">
      <ush-dates-carousel *ngIf="!newWorkflow" [dates]="dates" (itemSelected)="setHours($event)"></ush-dates-carousel>
      <div class="hours-wrapper">
        @for (hour of hours; track $index) {
        <ush-ui-hour [hour]="hour" (hourSelected)="changeHour(hour)"></ush-ui-hour>
        }
      </div>
    </div>
  </div>
</div>